import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";

import ApiHelper from "../../../Helpers/ApiHelper";
import ReportItemMapper from "./ReportItemMapper";
import Overlay from "../../SharedComponents/Overlay";
import { useDispatch, useSelector } from "react-redux";

import "../Styles/index.css";
import "../Styles/WrapUp.css";
import "animate.css";

import WrapUpHeader from "./WrapUpHeader";
import TestPdfButton from "../../PdfDownloadButton/Components/TestPdfButton";
import { UpdateAlertModalData } from "../../SharedComponents/GeneralModals/Store";

export default function TestWrapUp() {
  const user = useSelector((state) => state.auth.user);
  const { testResultId } = useParams();
  const dispatch = useDispatch();
  const [appData, setAppData] = useState([]);
  const [resultData, setResultData] = useState(null);
  const [showOverlay, setShowOverlay] = useState(true);

  useEffect(() => {
    if (testResultId) {
      ApiHelper.getAsync(
        "ticket/GetTestCalculation",
        { id: testResultId },
        function (response) {
          if (response.data.statusCode) MapResponse(response.data.data);
          else {
            dispatch(UpdateAlertModalData({ isShown: false, header: "calculationError", text: response.data.message }));
          }
        },
        user.token
      );
    } else {
      setShowOverlay(false);
      alert("problem");
    }
  }, [testResultId, user.token]);

  const CreateQrUrl = () => {
    return window.location.origin + "/#/tResult/" + testResultId;
  };

  let MapResponse = (resultData) => {
    setResultData(resultData);
    const scheme = JSON.parse(resultData.wrapUpJson);
    const calculation = JSON.parse(resultData.calculationJson);
    const calculatedScopes = calculation?.calculatedScopes;

    scheme.forEach((reportItem) => {
      if (reportItem.htmlEl) return;
      else if (reportItem.scales) {
        reportItem.score = calculation.testScore;
      } else reportItem.score = calculatedScopes.find((x) => x.scopeId === reportItem.scopeId)?.score;
    });

    setAppData({ scheme, resultData });
    setShowOverlay(false);
  };

  return (
    <Container className={"mt-3"}>
      {showOverlay && <Overlay text=" Sonuçlar hazırlanıyor" />}

      <WrapUpHeader resultData={appData.resultData} CreateQrUrl={CreateQrUrl}>
        <TestPdfButton
          testResultId={testResultId}
          resultData={resultData}
          docTitle={resultData?.demography?.name + " " + resultData?.applicationName ?? "unknown_pdf_name"}
        />
      </WrapUpHeader>

      <ReportItemMapper calculatedScheme={appData.scheme} type={"test"} />
    </Container>
  );
}
